// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__Y8IXw","title":"banner_title__3m_lw"};